import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled, { DefaultThemeProps, css } from 'styled-components';

const FormOptionCardItemStyles = ({ theme }: DefaultThemeProps) => css`
	/* Since there is no other selector to use we have to use the data-test attribute */
	[data-test^='form-block-option-'] > div:nth-child(2) {
		gap: ${pxToRem(theme.spacing['100'])};
	}
`;

export const FormOptionCardContainer = styled.div`
	${FormOptionCardItemStyles}
`;
